<template >
  <nav aria-label="top navigatie">
    <ul class="m-header-top__list" v-if="props.menuItems && props.menuItems.length > 0">
      <li v-for="item of props.menuItems" :class="{'m-dropdown__top': item.items && item.items.length > 0 }">
        <a :href="item.url" class="m-header-top__link" :class="{'active': item.active}">{{ item.name }}</a>
        <ul class="m-dropdown__top-menu" id="sweets-dropdown" v-if="item.items && item.items.length > 0">
          <li><a class="m-header-top__link" :class="{'active': subItem.active}" :href="subItem.url" v-for="subItem of item.items">{{ subItem.name }}</a></li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { MenuItem } from '../stores/menu'

const props = defineProps({
  menuItems: {
    type: Array<MenuItem>,
    default: [],
  },
})

</script>
